/* Cart sections replace nodes; remember displayed values independently of discount-dependent line keys. */
if (!customElements.get('teema-cart-number')) {
  customElements.define('teema-cart-number', class extends HTMLElement {
    static values = new Map();
    connectedCallback() {
      this.key = `${this.dataset.line}:${this.dataset.kind}:${this.dataset.currency}`;
      const target = Number(this.dataset.value);
      if (!Number.isFinite(target)) return;
      const values = this.constructor.values;
      const from = values.get(this.key);
      const finalText = this.textContent;
      values.set(this.key, target);
      if (from === undefined || from === target || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let formatter;
      try { formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency, currencyDisplay:'narrowSymbol'}); }
      catch (_) { return; }
      let start;
      const tick = now => {
        start ??= now;
        const progress = Math.min(1, (now - start) / 600);
        const value = Math.round(from + (target - from) * (1 - (1 - progress) ** 3));
        values.set(this.key, value);
        this.textContent = progress === 1 ? finalText : this.dataset.kind === 'percent' ? `${value}% OFF` : `${formatter.format(value / 100)}${this.dataset.currencyCode === 'true' ? ` ${this.dataset.currency}` : ''}`;
        if (progress < 1) this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); }
  });
}
